import { render, staticRenderFns } from "./ListViewTemplate.vue?vue&type=template&id=3dcb663a&scoped=true&"
import script from "./ListViewTemplate.vue?vue&type=script&lang=js&"
export * from "./ListViewTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dcb663a",
  null
  
)

export default component.exports